import React from 'react';
import { Modal } from 'antd';
import { DetailedSparkJobDTO } from 'types/types';
import { JobCodeContent } from './Contents/JobCodeContent';
import './JobCodeModal.scss';

const JobCodeModal: React.FC<{
  job: DetailedSparkJobDTO | undefined;
  onClose: () => void;
  isLoading: boolean;
  clusterName: string;
  isOpen: boolean;
}> = ({ job, onClose, isLoading, isOpen }) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width="calc(90vw - 650px)"
      closable
      title={null}
      className="job-code-modal"
      style={{
        position: 'fixed',
        left: 90,
        top: 50,
        margin: 0,
        paddingBottom: 0,
      }}
      styles={{ mask: { backdropFilter: 'blur(2px)' } }}>
      <div className="job-code__header">
        <p className="job-code__eyebrow">Job Code</p>
        <p className="job-code__job-id">{job?.sparkJobId ?? '—'}</p>
      </div>
      <JobCodeContent job={job} isLoading={isLoading} />
    </Modal>
  );
};

export default JobCodeModal;
